import { defineComponent, PropType, h, Component } from 'vue'
import { NuxtImg } from '#components'
import './index.scss'

type ImageFit = 'none' | 'contain' | 'cover' | 'fill' | 'scale-down'
type NameShowType = 'none' | 'hover' | 'override' | 'down'

export default defineComponent({
  name: 'GfrImage',
  props: {
    width: {
      type: [String, Number],
      default: 'auto'
    },
    height: {
      type: [String, Number],
      default: 'auto'
    },
    fit: {
      type: String as PropType<ImageFit>,
      default: 'none'
    },
    lazy: Boolean,
    src: String,
    name: String,
    alt: String,
    previewList: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    nameShow: {
      type: String as PropType<NameShowType>,
      default: 'none'
    },
    events: {
      type: String as PropType<'none' | 'auto'>,
      default: 'auto'
    },
    quality: {
      type: Number,
      default: 80
    },
    format: {
      type: String,
      default: 'webp'
    }
  },
  emits: ['load', 'error'],
  setup(props, { emit }) {
    const handleLoad = (event: Event) => {
      emit('load', event)
    }
    const handleError = (event: Event) => {
      emit('error', event)
    }

    return () => (
      <div class={'gfr-image'}>
        {h(NuxtImg as Component, {
          class: ['gfr-image-inner', `gfr-image-inner-${props.fit}`, props.lazy && 'gfr-image-lazy'],
          src: props.src,
          alt: props.alt || props.name || '',
          loading: props.lazy ? 'lazy' : 'eager',
          width: props.width,
          height: props.height,
          quality: props.quality,
          format: props.format,
          onLoad: handleLoad,
          onError: handleError
        })}
        {props.name && props.nameShow !== 'none' && (
          <span class={['gfr-image-name', `gfr-image-name-${props.nameShow}`]}>{props.name}</span>
        )}
      </div>
    )
  }
})
